import SliderHost from '@/components/SliderHost.vue'
import SimpleCollectionHost from '@/components/SimpleCollectionHost.vue'
import FeaturedCollectionHost from '@/components/FeaturedCollectionHost.vue'
import CollectionGroupHost from '@/components/CollectionGroupHost.vue'
import SimpleArticle from '@/components/SimpleArticle.vue'
import LinkCardVertical from '@/components/LinkCardVertical.vue'
import LinkCardHorizontal from '@/components/LinkCardHorizontal.vue'
import ContactUs from '@/components/ContactUs.vue'
import CollectionsCarouselHost from '@/components/CollectionsCarouselHost.vue'

export default {
  name: 'LeafComponentSelector',
  components: {
    SliderHost,
    SimpleCollectionHost,
    FeaturedCollectionHost,
    CollectionGroupHost,
    SimpleArticle,
    LinkCardVertical,
    LinkCardHorizontal,
    ContactUs,
    CollectionsCarouselHost
  },
  methods: {
    getVueComponent (componentType) {
      switch (componentType) {
        case 'slider':
          return SliderHost
        case 'simpleCollection':
          return SimpleCollectionHost
        case 'featuredCollection':
          return FeaturedCollectionHost
        case 'collectionGroup':
          return CollectionGroupHost
        case 'simpleArticle':
          return SimpleArticle
        case 'linkCardVertical':
          return LinkCardVertical
        case 'linkCardHorizontal':
          return LinkCardHorizontal
        case 'contactus':
          return ContactUs
        case 'genres':
          return CollectionsCarouselHost
        default:
          return null
      }
    }
  }
}
